import { useCallback } from 'react'

import { useOrganizationQuery, useUpdateUserInOrganizationMutation } from '~generated/hooks'
import { UserRolesInOrganizationTypes } from '~generated/types'
import useCurrentUser from '~hooks/apollo/useCurrentUser'

function useRequestEditAccess() {
  const [updateUserRole, options] = useUpdateUserInOrganizationMutation()

  const user = useCurrentUser()
  const { data } = useOrganizationQuery()

  const updateUserRolesInLaunchModule = useCallback(() => {
    const orgUser = data?.organization.users.find((u) => u.userId === user.id)

    if (user && orgUser) {
      updateUserRole({
        variables: {
          input: {
            userId: user.id,
            role: UserRolesInOrganizationTypes.EDITOR,
            inviteAccepted: orgUser.inviteAccepted,
          },
        },
      })
    }
  }, [data?.organization.users, user, updateUserRole])

  return [updateUserRolesInLaunchModule, options] as const
}

export default useRequestEditAccess
